import { Image } from "../../types/dto/common/image";

const imageFactory = (data: any): Image => {
  if (!data) return {} as Image;
  return {
      imageUrl: data?.imageUrl ?? data?.url ?? "",
      altText: data?.altText ?? data?.alt ?? ""
  };
};

export default imageFactory;
